import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './NotFound.css';
import history from '../../history';

class NotFound extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.notFound}>
        <svg height="512" width="512" xmlns="http://www.w3.org/2000/svg">
          <path d="M136 121l-16 96H56l-16-96" fill="#fff" />
          <path d="M72 217h32v216H72z" fill="#b9c2cf" />
          <path d="M88 217h16v216H88zM152 121H24l64-64z" fill="#95a4b6" />
          <path d="M88 57L76 69l52 52h24z" fill="#72869e" />
          <path d="M24 433a32 32 0 0164 0" fill="#b9c2cf" />
          <path
            d="M56 401l-8 1c14 4 24 16 24 31h16c0-17-14-32-32-32z"
            fill="#95a4b6"
          />
          <path d="M88 433a48 48 0 1196 0" fill="#b9c2cf" />
          <path
            d="M136 385l-8 1c23 4 40 23 40 47h16c0-26-21-48-48-48z"
            fill="#95a4b6"
          />
          <path d="M6 433h500v24H6z" fill="#dce1e7" />
          <path d="M486 433h20v24h-20zM208 361h280v32H208z" fill="#b9c2cf" />
          <path d="M208 377h280v16H208z" fill="#95a4b6" />
          <path d="M232 297h224v32H232z" fill="#b9c2cf" />
          <path d="M436 297h20v32h-20z" fill="#95a4b6" />
          <path d="M232 233h224v32H232z" fill="#b9c2cf" />
          <path d="M436 233h20v32h-20z" fill="#95a4b6" />
          <path
            d="M478 427v-28h16v-44h-56v-20h24v-44h-24v-20h24v-44H226v44h24v20h-24v44h24v20h-48v44h16v28h-28a54 54 0 00-80-41V223h34v-12h-17l14-84h25L88 49l-78 78h25l14 84H32v12h34v174a38 38 0 00-48 30H0v36h512v-36zM238 239h212v20H238zm24 32h164v20H262zm-24 32h212v20H238zm24 32h164v20H262zm-48 32h268v20H214zm16 32h236v28H230zm-30 40v12h-88v-12zm12 0h88v12h-88zm100 0h88v12h-88zm-176-48c21 0 39 16 42 36H94c2-10 7-19 15-26h1v-1c7-5 16-9 26-9zm-21-180H94v-84h35zM88 66l50 49H38zm-41 61h35v84H61zm31 96h20v172c-5 5-8 10-11 16l-9-9zM56 407c12 0 23 9 25 20H31c2-11 13-20 25-20zm-44 32h88v12H12zm488 12h-88v-12h88z"
            fill="#012d4a"
          />
        </svg>
        <div>
          <p>This page does not exist</p>
          <button onClick={() => history.push('/')}>
            <span className="mdi mdi-home" />
            Go home
          </button>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(NotFound);



// WEBPACK FOOTER //
// ./src/routes/not-found/NotFound.js